import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ErrorIcon, InfoIcon, QuestionIcon, SuccessIcon, WarningIcon } from '@/utils/common/svgIcons';
import React, { ReactNode, useEffect, useRef } from 'react';
interface NotifyDialogProps {
  title: string;
  open: boolean;
  onClose: () => void;
  onYes?: () => void;
  yesText?: string;
  onNo?: () => void;
  noText?: string;
  onCancel?: () => void;
  cancelText?: string;
  description?: string | string[] | ReactNode;
  type?: 'success' | 'error' | 'info' | 'warning' | 'question' | 'none';
  loading?: boolean;
  autoFocusButton?: 'yes' | 'no' | 'cancel';
}
const NotifyModel: React.FC<NotifyDialogProps> = ({
  title,
  open,
  onClose,
  onYes,
  onNo,
  onCancel,
  description,
  type,
  yesText = 'Yes',
  noText = 'No',
  cancelText = 'Cancel',
  loading = false,
  autoFocusButton = 'cancel'
}) => {
  const yesRef = useRef<HTMLButtonElement>(null);
  const noRef = useRef<HTMLButtonElement>(null);
  const cancelRef = useRef<HTMLButtonElement>(null);
  const getIcon = () => {
    switch (type) {
      case 'none':
        return null;
      case 'success':
        return SuccessIcon();
      case 'error':
        return ErrorIcon();
      case 'warning':
        return WarningIcon();
      case 'question':
        return QuestionIcon();
      case 'info':
      default:
        return InfoIcon();
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      switch (autoFocusButton) {
        case 'yes':
          yesRef.current?.focus();
          break;
        case 'no':
          noRef.current?.focus();
          break;
        case 'cancel':
          cancelRef.current?.focus();
          break;
      }
    }, 0);
    return () => clearTimeout(timer);
  }, [autoFocusButton, open]);
  return <Dialog open={open} onOpenChange={onClose} data-sentry-element="Dialog" data-sentry-component="NotifyModel" data-sentry-source-file="NotifyModel.tsx">
      <DialogContent className="" data-sentry-element="DialogContent" data-sentry-source-file="NotifyModel.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="NotifyModel.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="NotifyModel.tsx">{title}</DialogTitle>
        </DialogHeader>
        <div className="dialog-drag-handle flex min-w-0 cursor-move items-center gap-2 overflow-hidden break-words" style={{
        whiteSpace: 'pre-line'
      }}>
          <div>{getIcon()}</div>
          {description}
        </div>
        <DialogFooter className="flex w-full items-center justify-center gap-2" data-sentry-element="DialogFooter" data-sentry-source-file="NotifyModel.tsx">
          {onYes && <Button ref={yesRef} type="button" variant={'outline'} className="w-full max-w-[150px]" onClick={onYes}>
              {yesText}
            </Button>}
          {onNo && <Button ref={noRef} type="button" variant={'outline'} className="w-full max-w-[150px]" disabled={loading} onClick={onNo}>
              {noText}
            </Button>}
          {onCancel && <Button ref={cancelRef} type="button" variant={'outline'} className="w-full max-w-[150px]" onClick={onCancel} disabled={loading}>
              {cancelText}
            </Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>;
};
export default NotifyModel;